import frLocales from "@/locales/catalogues/fr_FR.json";
import nlLocales from "@/locales/catalogues/nl_NL.json";
import enLocales from "@/locales/catalogues/en_US.json";

interface AppLocales {
  locales: Locales[];
  defaultLocale: Locales;
  defaultNs: Locales;
}

export const appLanguages = {
  nl: {
    name: "Nederlands",
    locale: "nl",
    prismicLocales: "nl-be",
    direction: "ltr",
    locales: nlLocales,
  },
  fr: {
    name: "Français",
    locale: "fr",
    prismicLocales: "fr-fr",
    direction: "ltr",
    locales: frLocales,
  },
  en: {
    name: "English",
    locale: "en",
    prismicLocales: "en-us",
    direction: "ltr",
    locales: enLocales,
  },
};

export type Locales = keyof typeof appLanguages;

export const appLocales: AppLocales = {
  locales: Object.entries(appLanguages).map(([key]) => key as Locales),
  defaultLocale: "fr",
  defaultNs: "en",
};

export const getPrismicLocale = (locale: Locales) => {
  return appLanguages[locale].prismicLocales;
};

export function getLocalFromPrismic(prismicLocale: string) {
  return Object.entries(appLanguages).find(([, value]) => value.prismicLocales === prismicLocale)?.[0] as Locales;
}
